export enum EEslDatetimeLanguage {
    English = 1,
    French = 2,
    Spanish = 3,
    BilingualFrenchEnglish = 4,
    BilingualEnglishFrench = 5,
}
export type EEslDatetimeLanguageKeysType = keyof typeof EEslDatetimeLanguage;
